import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	processedInvoiceQueries,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import UpdateNonProjectInvoiceDescriptionForm
	from "~/modules/billing/components/InvoiceDetailsView/components/UpdateNonProjectInvoiceDescriptionSidebar/UpdateNonProjectInvoiceDescriptionForm.tsx";

type Props = {
	invoiceData: Invoice;
	isOpen: boolean;
	onClose: () => void;
};

const UpdateNonProjectInvoiceDescriptionSidebar = ({
	invoiceData,
	isOpen,
	onClose,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		await queryClient.refetchQueries({ queryKey: processedInvoiceQueries.details(invoiceData.id).queryKey });
		onClose();
	}, [invoiceData.id, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateNonProjectInvoiceDescriptionForm onCancel={onClose}
															   onSuccess={handleSuccess}
															   invoiceData={invoiceData} />}
		</Sidebar>
	);
};

export default UpdateNonProjectInvoiceDescriptionSidebar;
